import { useDispatch, useSelector } from "react-redux";
import { Grid, Tooltip } from "@material-ui/core";
import CustomizedTables from "../../atoms/table";
import { StyledTableCell, StyledTableRow } from "../../atoms/table/tableStyles";
import { convertToLocalTime } from "../../../utils/commonUtils";
import { invokeGetService } from "../../../store/global/actions";
import { useEffect } from "react";
import { useState } from "react";
import { getReRender } from "../../../store/global/selectors";


const tableHeader = [
    { label: 'Version', _id: 'version' },
    { label: 'Type', _id: 'type' },
    { label: 'Migrated by', _id: 'migratedBy' },
    { label: 'Date of Migration', _id: 'migrateddate' }
]

export const PlatformSchemaVersionHistory = ({ isMigrating }) => {
    const dispatch = useDispatch();

    const reRender = useSelector(getReRender);

    const [versionHistory, setVersionHistory] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (!isMigrating) {
            fetchBlueprintPlatformSchemaHistory();
        }
    }, [isMigrating, reRender])


    const fetchBlueprintPlatformSchemaHistory = () => {
        setIsFetching(true);
        dispatch(invokeGetService('getBlueprintPlatformSchemaHistory', [])).then((response) => {
            if (response?.status === true && response.data) {
                const sortedHistory = response.data.history.sort(
                    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                );

                setVersionHistory(sortedHistory || []);
            }
            setIsFetching(false);
        });
    }



    return (
        <Grid item xs={12}>

            <CustomizedTables dataUiTourId="platformschema-history-table" size="small" headers={tableHeader} id="schema_history_table">
                {isFetching ? <StyledTableRow>
                    <StyledTableCell align={'center'} colSpan={5} component="td" style={{ padding: 15 }}>
                        Loading..
                    </StyledTableCell>
                </StyledTableRow>

                    :
                    versionHistory?.length < 1 ? (
                        <StyledTableRow>
                            <StyledTableCell align={'center'} colSpan={5} component="td" style={{ padding: 15 }}>
                                No platform schema has been used for this blueprint yet
                            </StyledTableCell>
                        </StyledTableRow>
                    ) : (
                        versionHistory?.map((item, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell align={'left'}>{item.platformSchemaVersion}</StyledTableCell>
                                <StyledTableCell align={'left'}>
                                    <Tooltip title={item.isDefaultPlatformSchema ? "Provided and maintained by HyperBlox" : "Custom schema created by blueprint owner"}>
                                        <span>
                                            {item.isDefaultPlatformSchema ? "System" : "Local"}
                                        </span>
                                    </Tooltip>
                                </StyledTableCell>
                                <StyledTableCell align={'left'}>{item.username || ""}</StyledTableCell>
                                <StyledTableCell align={'left'}>{convertToLocalTime(item.updatedAt)}</StyledTableCell>
                            </StyledTableRow>
                        ))
                    )}
            </CustomizedTables>
        </Grid>
    )
}